import railyApiService from "../raily-api.service";
import candidatureAddByOrderIdRequestFactory from "./add-by-order-id/candidature-add-by-order-id-request.factory";
import CandidatureAddByOrderIdRequest, {
  CandidatureAddByOrderIdRequestBody,
} from "./add-by-order-id/candidature-add-by-order-id.request";
import CandidatureAddByOrderIdResponse from "./add-by-order-id/candidature-add-by-order-id.response";
import candidatureAddRequestFactory from "./add/candidature-add-request.factory";
import CandidatureAddRequest, {
  CandidatureAddRequestBody,
} from "./add/candidature-add.request";
import CandidatureAddResponse from "./add/candidature-add.response";
import candidaturePreviewRequestFactory from "./preview/candidature-preview-request.factory";
import CandidaturePreviewRequest, {
  CandidaturePreviewRequestQueryParams,
} from "./preview/candidature-preview.request";
import CandidaturePreviewResponse from "./preview/candidature-preview.response";

const candidatureApiService = () => {
  const add = (
    request: CandidatureAddRequest,
    abortSignal: AbortSignal,
  ): Promise<CandidatureAddResponse> => {
    const url = `/candidatures`;

    const body: CandidatureAddRequestBody =
      candidatureAddRequestFactory.createBody(request);

    return railyApiService().post<CandidatureAddResponse>({
      url,
      abortSignal,
      body,
    });
  };

  const addByOrderId = (
    request: CandidatureAddByOrderIdRequest,
    abortSignal: AbortSignal,
  ): Promise<CandidatureAddByOrderIdResponse> => {
    const url = `/candidatures/for-cargo-order`;

    const body: CandidatureAddByOrderIdRequestBody =
      candidatureAddByOrderIdRequestFactory.createBody(request);

    return railyApiService().post<CandidatureAddByOrderIdResponse>({
      url,
      abortSignal,
      body,
    });
  };

  const getPreview = (
    request: CandidaturePreviewRequest,
    abortSignal: AbortSignal,
  ): Promise<CandidaturePreviewResponse> => {
    const url = `/candidatures/staging/${request.orderId}`;

    const queryParams: CandidaturePreviewRequestQueryParams =
      candidaturePreviewRequestFactory.createQueryParams(request);

    return railyApiService().get({
      url,
      abortSignal,
      queryParams,
    });
  };

  return {
    add,
    addByOrderId,
    getPreview,
  };
};

export default candidatureApiService;
